import { ErrorBase } from "@util/errors";

export class UpsertSachbezugDivisionError extends ErrorBase {
	constructor(reason?: string) {
		super(
			`Die Abteilung wurde gespeichert, aber die Sachbezug-Einstellungen konnten nicht gespeichert werden.\nGrund: ${
				reason ?? "unbekannt"
			}`
		);
	}
}
